<template>
  <div v-if="canAccessPage">
    <dashboard-inicial-varejo-filtro
      v-model="abrirFiltro"
      @DashboardInicialFiltro__AplicaFiltros="aplicarFiltros"
      @FiltroRapido__HabilitaIconBadge="habilitaIconBadge"
      @DashboardInicialFiltro__FiltrosCarregados="setarFiltrosCarregados">
    </dashboard-inicial-varejo-filtro>

    <v-container fluid grid-list-md pa-0>
      <v-row align="center" justify="end" class="font-weight-black" style="min-height: 50px">
        <v-col cols="12" class="text-right">
          <v-badge
              bordered
              color="orange"
              icon="mdi-lock"
              overlap
              v-show="!abrirFiltro"
              v-if="habilitarIconBadge">
              <v-icon v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
          </v-badge>
          <v-icon v-else v-show="!abrirFiltro" @click="abrirFiltro = !abrirFiltro">filter_list</v-icon>
        </v-col>
      </v-row>

      <v-row no-gutters class="mt-0">

        <v-col
          cols="12"
          :md="exibirColunaDireita ? 8 : 12"
          class="d-flex flex-column"
          :class="{ 'pr-md-8': exibirColunaDireita }"
          :style="exibirColunaDireita ? 'border-right: 4px solid #E0E0E0; min-height: 70vh;' : ''"
        >
          <v-row no-gutters>
            <v-col cols="12" class="d-flex justify-center mt-n2">
              <img
                src="../../assets/img/logo-tradelinks-horizontal-azul.png"
                alt="Logo TradeLinks"
                style="max-width: 100%; height: auto; max-height: 80px;"
              />
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-n2">
            <v-col cols="12">
              <liquidacao-cards-totalizadores
                v-if="!possuiPermissaoApuracaoMassiva && filtrosCarregados"
                ref="cards_totalizadores"
                :filtros="filtros"
                percentual="quantidade">
              </liquidacao-cards-totalizadores>

              <dashboard-cards-pendencias-totalizadores
                v-if="possuiPermissaoApuracaoMassiva"
                ref="cards_pendencias_totalizadores"
                :possui-permissao-apuracao-massiva-acoes-apuracoes="possuiPermissaoApuracaoMassivaAcoesApuracoes"
                :possui-permissao-pendencias-de-analise="possuiPermissaoPendenciasDeAnalise"
                :possui-permissao-apuracao-massiva-contratos="possuiPermissaoApuracaoMassivaContratos"
                @abrirModalPendencias="abrirModalPendencias"
              />
            </v-col>
          </v-row>

          <v-row
            no-gutters
            class="d-flex justify-center"
            :class="possuiPermissaoApuracaoMassiva ? 'mt-8' : 'mt-auto mb-10'"
          >
            <v-col cols="12" class="d-flex justify-center">
              <img
                src="../../assets/img/fundo-home-trade.png"
                alt="TradeLinks Home"
                :style="possuiPermissaoApuracaoMassiva
                  ? 'width: 100%; max-width: 380px; height: auto;'
                  : 'width: 100%; max-width: 500px; height: auto;'"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col v-if="exibirColunaDireita" cols="12" md="4" class="pl-md-8 pt-0">
          <v-row no-gutters>
            <v-col cols="12" class="mb-2" v-if="!possuiPermissaoApuracaoMassivaAcoesApuracoes || !possuiPermissaoApuracaoMassivaContratos">
              <dashboard-pendencias-planejamento
                v-if="filtrosCarregados"
                :filtros="filtros"
              />
            </v-col>

            <v-col cols="12" class="mb-2" v-if="!possuiPermissaoApuracaoMassivaAcoesApuracoes">
              <dashboard-pendencias-apuracao
                v-if="filtrosCarregados"
                :filtros="filtros"
              />
            </v-col>

            <v-col cols="12" class="mb-2" v-if="!possuiPermissaoPendenciasDeAnalise">
              <dashboard-pendencias-em-analise
                v-if="filtrosCarregados"
                :filtros="filtros"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-container>
    <dashboard-modal-pendencias
      ref="modalPendencias"
      v-if="modalPendencias"
      v-model="modalPendencias"
      :abrir-modal-pendencia="abrirModalPendencia"
      @DashboardModalPendencias__fechar="fecharModalPendencia">
    </dashboard-modal-pendencias>
    <dashboard-modal-pendencias-contratos
    ref="modalPendenciasContratos"
    v-if="modalPendenciasContratos"
    v-model="modalPendenciasContratos"
    :abrir-modal-pendencia-contrato="abrirModalPendenciaContratos"
    @DashboardModalPendenciasContrato__fechar="fecharModalPendenciaContrato">
  </dashboard-modal-pendencias-contratos>
    <dashboard-modal-pendencias-em-analise
      ref="modalPendenciasEmAnalise"
      v-if="modalPendenciasEmAnalise"
      v-model="modalPendenciasEmAnalise"
      :abrir-modal-pendencia-em-analise="abrirModalPendenciaEmAnalise"
      :lista-pendencias-em-analise-carregada="listaPendenciasEmAnalise"
      @DashboardModalPendenciasEmAnalise__fechar="fecharModalPendenciaEmAnalise">
    </dashboard-modal-pendencias-em-analise>
  </div>
</template>

<script type="text/javascript">
import moment from 'moment';
import { mapGetters } from 'vuex';
import ApuracaoCardsTotalizadores from '@/spa/apuracao-acao/ApuracaoCardsTotalizadores';
import DashboardFuncionarioVarejoRankingRecebimento from '@/spa/dashboard/DashFuncionarioVarejoRankingRecebimento';
import DashboardVarejoGrafico from '@/spa/dashboard/DashVarejoGrafico';
import DashboardPendenciasApuracao from '@/spa/dashboard/DashboardPendenciasApuracao';
import DashboardPendenciasPlanejamento from '@/spa/dashboard/DashboardPendenciasPlanejamento';
import DashboardInicialVarejoFiltro from '@/spa/dashboard/DashboardInicialVarejoFiltro';
import DashboardPendenciasEmAnalise from '@/spa/dashboard/DashboardPendenciasEmAnalise';
import DashboardCardsPendenciasTotalizadores from '@/spa/dashboard/DashboardCardsPendenciasTotalizadores';
import DashboardModalPendencias from '@/spa/dashboard/DashboardModalPendencias';
import DashboardModalPendenciasContratos from '@/spa/dashboard/DashboardModalPendenciasContratos';
import DashboardModalPendenciasEmAnalise from '@/spa/dashboard/DashboardModalPendenciasEmAnalise';
import LiquidacaoCardsTotalizadores from '../liquidacao-acao/LiquidacaoCardsTotalizadores';

export default {
  name: 'DashboardInicial',
  data() {
    return {
      filtros: {},
      abrirFiltro: false,
      habilitarIconBadge: false,
      abrirModalPendencia: false,
      abrirModalPendenciaContratos: false,
      abrirModalPendenciaEmAnalise: false,
      modalPendencias: null,
      modalPendenciasContratos: null,
      modalPendenciasEmAnalise: null,
      filtrosCarregados: false,
      listaPendenciasEmAnalise: null,
    };
  },
  components: {
    ApuracaoCardsTotalizadores,
    LiquidacaoCardsTotalizadores,
    DashboardVarejoGrafico,
    DashboardInicialVarejoFiltro,
    DashboardPendenciasApuracao,
    DashboardPendenciasPlanejamento,
    DashboardFuncionarioVarejoRankingRecebimento,
    DashboardPendenciasEmAnalise,
    DashboardCardsPendenciasTotalizadores,
    DashboardModalPendencias,
    DashboardModalPendenciasContratos,
    DashboardModalPendenciasEmAnalise,
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'DASH_VAREJO').length;
    },
    possuiPermissaoApuracaoMassivaAcoesApuracoes() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'APU_MASSIVA_ACOES_APURACOES').length;
    },
    possuiPermissaoPendenciasDeAnalise() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'PENDENCIAS_DE_ANALISE').length;
    },
    possuiPermissaoApuracaoMassivaContratos() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'APU_MASSIVA_CONTRATOS').length;
    },
    possuiPermissaoApuracaoMassiva() {
      if (this.possuiPermissaoApuracaoMassivaAcoesApuracoes || this.possuiPermissaoPendenciasDeAnalise
       || this.possuiPermissaoApuracaoMassivaContratos) {
        return true;
      }
      return false;
    },
    naoPossuiAlgumaPermissaoApuracaoMassiva() {
      if (!this.possuiPermissaoApuracaoMassiva
      || (this.possuiPermissaoApuracaoMassiva
      && (!this.possuiPermissaoApuracaoMassivaAcoesApuracoes
      || !this.possuiPermissaoPendenciasDeAnalise
      || !this.possuiPermissaoApuracaoMassivaContratos))) {
        return true;
      }
      return false;
    },
    desabilitaBuscaContratoPendencia() {
      if (!this.possuiPermissaoApuracaoMassivaAcoesApuracoes && this.possuiPermissaoApuracaoMassivaContratos) {
        return true;
      }
      return false;
    },
    desabilitaBuscaAcaoPendencia() {
      if (this.possuiPermissaoApuracaoMassivaAcoesApuracoes && !this.possuiPermissaoApuracaoMassivaContratos) {
        return true;
      }
      return false;
    },
    exibirColunaDireita() {
      const planejamento = !this.possuiPermissaoApuracaoMassivaAcoesApuracoes || !this.possuiPermissaoApuracaoMassivaContratos;
      const apuracao = !this.possuiPermissaoApuracaoMassivaAcoesApuracoes;
      const emAnalise = !this.possuiPermissaoPendenciasDeAnalise;
      return (planejamento || apuracao || emAnalise) && this.filtrosCarregados;
    },
  },
  methods: {
    abrirModalPendencias(modal, listaPendenciasEmAnalise) {
      if (modal.status === 'PENDENCIAS_NDS') {
        this.modalPendencias = modal;
        setTimeout(() => { this.abrirModalPendencia = true; }, 2E2);
      }
      if (modal.status === 'PENDENCIAS_CONTRATO') {
        this.modalPendenciasContratos = modal;
        setTimeout(() => { this.abrirModalPendenciaContratos = true; }, 2E2);
      }
      if (modal.status === 'PENDENCIAS_ANALISE') {
        this.modalPendenciasEmAnalise = modal;
        if (listaPendenciasEmAnalise !== null) {
          this.listaPendenciasEmAnalise = listaPendenciasEmAnalise;
        }
        setTimeout(() => { this.abrirModalPendenciaEmAnalise = true; }, 2E2);
      }
    },
    fecharModalPendencia(pendenciaExecutada) {
      this.abrirModalPendencia = false;
      setTimeout(() => { this.modalPendencias = null; }, 2E2);
      if (pendenciaExecutada) {
        this.$refs.cards_pendencias_totalizadores.buscaTotalizadores();
      }
    },
    fecharModalPendenciaContrato(pendenciaExecutada) {
      this.abrirModalPendenciaContratos = false;
      setTimeout(() => { this.modalPendenciasContratos = null; }, 2E2);
      if (pendenciaExecutada) {
        this.$refs.cards_pendencias_totalizadores.buscaTotalizadores();
      }
    },
    fecharModalPendenciaEmAnalise(pendenciaExecutada) {
      this.abrirModalPendenciaEmAnalise = false;
      setTimeout(() => { this.modalPendenciasEmAnalise = null; }, 2E2);
      if (pendenciaExecutada) {
        this.$refs.cards_pendencias_totalizadores.buscaTotalizadores();
      }
    },
    aplicarFiltros(filtrosAplicados) {
      if (!filtrosAplicados || !this.filtroPeriodoValido(filtrosAplicados)) {
        return;
      }
      if (!filtrosAplicados.data_inicio && !filtrosAplicados.data_fim) {
        filtrosAplicados.data_inicio = moment(new Date(new Date().getFullYear(), 0, 1), 'DD-MM-YYYY')
          .format('YYYY-MM-DD');
        filtrosAplicados.data_fim = moment(new Date(new Date().getFullYear(), 11, 31), 'DD-MM-YYYY')
          .format('YYYY-MM-DD');
      }
      this.filtros = {
        ...filtrosAplicados,
        id_acao: filtrosAplicados.id_campanha ? filtrosAplicados.id_campanha : '',
        desabilita_contrato: this.desabilitaBuscaContratoPendencia ? this.desabilitaBuscaContratoPendencia : '',
        desabilita_acao: this.desabilitaBuscaAcaoPendencia ? this.desabilitaBuscaAcaoPendencia : '',
      };
    },
    habilitaIconBadge(valor) {
      this.habilitarIconBadge = valor;
    },
    filtroPeriodoValido(filtrosAplicados) {
      if (filtrosAplicados.data_inicio || filtrosAplicados.data_fim) {
        let dtInicio = '';
        let dtFinal = '';
        dtInicio = this.moment(filtrosAplicados.data_inicio, 'YYYY-MM-DD');
        dtFinal = this.moment(filtrosAplicados.data_fim, 'YYYY-MM-DD');

        if (dtFinal.isBefore(dtInicio)) {
          this.$toast(this.$t('message.data_final_antes_inicial'));
          return false;
        }
        if ((filtrosAplicados.data_inicio && !filtrosAplicados.data_fim)
          || (!filtrosAplicados.data_inicio && filtrosAplicados.data_fim)) {
          this.$toast(this.$t('message.data_final_e_inicial'));
          return false;
        }
        return true;
      }
      return true;
    },
    setarFiltrosCarregados() {
      this.filtrosCarregados = true;
    },
  },
  mounted() {
    if (this.$route.params && this.$route.params.modalDashboard) {
      if (this.$route.params.modalDashboard === 'PENDENCIAS_NDS') {
        this.modalPendencias = true;
        setTimeout(() => { this.abrirModalPendencia = true; }, 2E2);
      }
      if (this.$route.params.modalDashboard === 'PENDENCIAS_CONTRATO') {
        this.modalPendenciasContratos = true;
        setTimeout(() => { this.abrirModalPendenciaContratos = true; }, 2E2);
      }
      if (this.$route.params.modalDashboard === 'PENDENCIAS_ANALISE') {
        this.modalPendenciasEmAnalise = true;
        setTimeout(() => { this.abrirModalPendenciaEmAnalise = true; }, 2E2);
      }
    }
  },
};
</script>
